var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hue",on:{"mousedown":_vm.mouseEvents}},[_c('div',{ref:"hueRef",staticClass:"hue-area"},[_c('div',{staticClass:"picker-pointer",style:(_vm.pointerStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }